import classnames from 'classnames';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';

import Conversation from 'models/conversation';
import i18n from 'scripts/i18n/i18n';

const ConversationStatus = createReactClass({
  propTypes: {
    size: PropTypes.string,
    status: PropTypes.string.isRequired,
  },

  render() {
    return (
      <span className="conversation-status fa-stack" title={this.getStatusText()}>
        {this.renderCheckmark()}
      </span>
    );
  },

  renderCheckmark() {
    let icon = this.getCheckmarkIcon();
    let classNames = classnames('conversation-status-checkmark', 'fa', icon, this.props.size);
    return <i className={classNames} />;
  },

  getCheckmarkIcon() {
    let status = this.props.status;
    switch (status) {
      case Conversation.Status.WAITING:
        return 'fa-clock-o';
      case Conversation.Status.OPEN:
        return 'fa-circle-o';
      case Conversation.Status.CLOSED:
        return 'fa-check';
      default:
        throw new Error(`invalid status [${status}]`);
    }
  },

  getStatusText() {
    return ConversationStatus.getTextForStatus(this.props.status);
  },

  statics: {
    getTextForStatus(status) {
      switch (status) {
        case Conversation.Status.WAITING:
          return i18n.t('Waiting');
        case Conversation.Status.OPEN:
          return i18n.t('Open');
        case Conversation.Status.CLOSED:
          return i18n.t('Closed');
        default:
          throw new Error(`invalid status [${status}]`);
      }
    },
  },
});

export default ConversationStatus;
